import axios from "axios"

const forgotPassword = async (user: { email: string; userType: string }) => {
    try {
        const { data } = await axios.post(
            process.env.NEXT_PUBLIC_API_URL + "users/forgot-password",
            user
        )

        return data
    } catch (error: any) {
        return error.response.data
    }
}

export default forgotPassword
